/**
 * Created by brad on 3/28/16.
 */
import { Collection }   from 'backbone';
import AssetModel    from 'AssetModel.js';

//===============================================================
// A Backbone collection of a Form's Asset models.
// Each model has a reference to the Asset id, name, type and mimetype.
//===============================================================
class AssetCollection extends Collection {

    initialize() {
        this.model = AssetModel;
    }



}
const assetCollection = new AssetCollection();
export default assetCollection;
